import { HashType, ShaHasher } from '@iotize/common/crypto';
import { hexStringToBuffer } from '@iotize/common/byte-converter';

const ALGO_TYPE: HashType = 'sha1';
const ITERATION_NUMBER = 4096;
const KEY_SIZE = 128;
const DEFAULT_SALT = 'n0 salt in 1oTi2e'; // TODO read from iotize ...

export const passwordHasher = new ShaHasher({
  type: ALGO_TYPE,
  iterations: ITERATION_NUMBER,
  salt: DEFAULT_SALT,
  keySize: KEY_SIZE,
});
